import { matchPath } from 'react-router-dom'
import { APP_BOTTOM_NAV_TABS, AppBottomNavTabId } from 'businessTraveller/components/app-bottom-nav/appBottomNavTabs'
import {
  MOBILE_APP_BOTTOM_NAV_ROUTES,
  MOBILE_APP_BOTTOM_NAV_SOLID_BACKGROUND_ROUTES,
} from 'components/App/Routes/routeConstants'

function matchesAnyRoute(pathname: string, routes: Array<string>): boolean {
  return routes.some(path => !!matchPath(pathname, { path, exact: true }))
}

/** Whether the app bottom nav shows on `pathname` at all */
export function shouldShowAppBottomNav(pathname: string): boolean {
  return matchesAnyRoute(pathname, MOBILE_APP_BOTTOM_NAV_ROUTES)
}

/**
 * Get active tab based on the current path
 */
export function getAppBottomNavActiveTab(pathname: string): AppBottomNavTabId | undefined {
  return APP_BOTTOM_NAV_TABS.find(tab => matchesAnyRoute(pathname, tab.activeRoutes ?? []))?.id
}

/** Whether the app bottom nav should paint a solid background on `pathname` rather than float */
export function hasAppBottomNavSolidBackground(pathname: string): boolean {
  return matchesAnyRoute(pathname, MOBILE_APP_BOTTOM_NAV_SOLID_BACKGROUND_ROUTES)
}
